import React from 'react'
import './PostHeroSection.css'

function PostHeroSection() {
  const skills = ['Laravel', 'React', 'Next.js', 'WordPress', '.NET', 'Flutter', 'Node.js', 'AWS', 'Google Ads', 'Analytics', 'PostgreSQL']

  return (
    <section className="posthero-section">
      <div className="posthero-grid-bg"></div>
      <div className="posthero-container">
        <p className="posthero-badge">DIGITAL STUDIO · SRI LANKA × UAE</p>

        <h2 className="posthero-title">
          We build digital products
        </h2>

        <p className="posthero-subtitle">
          A small, senior team of engineers and designers shipping web, mobile and growth systems
          for ambitious teams across Sri Lanka, UAE and beyond.
        </p>

        <div className="posthero-actions">
          <a href="/contact-us" className="posthero-btn-primary">
            Request a quote <i className="bi bi-arrow-right"></i>
          </a>
          <a href="/our-works" className="posthero-btn-secondary">
            <span><i className="bi bi-play-fill"></i></span> See our work
          </a>
        </div>

        <div className="posthero-stats">
          <div><strong>120+</strong><small>PROJECTS SHIPPED</small></div>
          <div><strong>8 yrs</strong><small>BUILDING PRODUCTS</small></div>
          <div><strong>98%</strong><small>CLIENT RETENTION</small></div>
          <div><strong>2 HQs</strong><small>KANDY · DUBAI</small></div>
        </div>

        <div className="posthero-experts">
          <p>EXPERTS IN</p>
          <div>
            {skills.map((skill) => (
              <span key={skill}>{skill}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default PostHeroSection
